export default "__VITE_ASSET__CKMgwhBe__"